import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import type { LegacyExportTask } from './tasks/core/export-task-legacy';
import type { ExportTask } from './tasks/core/export-task';
import { ExportTaskStatus } from './tasks/core/export-task.enum';

@Injectable({ providedIn: 'root' })
export class ExportStoreService {
  tasks: Array<LegacyExportTask | ExportTask> = [];
  active$ = new BehaviorSubject(false);
  visible$ = new BehaviorSubject(false);
  busy$ = new BehaviorSubject(false);
  change$ = new Subject<void>();

  addTask(task: LegacyExportTask | ExportTask) {
    if (!this.tasks.some((someTask) => someTask.id === task.id)) {
      this.tasks.push(task);
    }
    this.active$.next(true);
    this.visible$.next(true);
    this.emitChange();
  }

  removeTask(id: string) {
    const index = this.tasks.findIndex((fromTask) => fromTask.id === id);
    if (index === -1) return;
    this.tasks.splice(index, 1);
    if (this.tasks.length === 0) {
      // No tasks left, make inactive and invisible the export overlay
      this.active$.next(false);
      this.visible$.next(false);
    }
    this.emitChange();
  }

  setVisible(value: boolean) {
    this.visible$.next(value);
  }

  /** When the progress or status of a task changes, this event notifies
   * the export overlay to redraw the list of tasks. */
  emitChange() {
    this.busy$.next(this.tasks.some((task) => task.status === ExportTaskStatus.Busy));
    this.change$.next();
  }
}
